
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buying-with-torii",
      function () {
        return require("private-next-pages/buying-with-torii/index.tsx");
      }
    ]);
  